<template>
  <div class="user-option">
    <el-dropdown class="user" trigger="click" @command="handleCommandUser" v-if="isLogin">
      <div class="flex">
        <div>
          <img
            :src="userAvatar"
            alt=""
            class="user-avatar"
            v-if="userAvatar.includes('/person.avatar') && !userAvatar.includes('auth0')"
          />
          <img src="@/assets/images/avatar-moren.png" class="user-avatar" alt="" v-else />
        </div>
        <span class="user-name">{{ displayName }}</span>
      </div>
      <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <el-dropdown-item command="info">{{ $t('my_account') }}</el-dropdown-item>
        <el-dropdown-item command="wallet" v-if="!isFree">{{ $t('my_wallet') }}</el-dropdown-item>
        <el-dropdown-item v-if="false">{{ $t('statistics_center') }}</el-dropdown-item>
        <el-dropdown-item command="history">{{ $t('learn_history') }}</el-dropdown-item>
        <el-dropdown-item :command="!isLearner ? 'assignment' : 'studentAssignment'">
          <el-badge :is-dot="isUnRead" :hidden="false">{{ $t('my_homework') }}</el-badge>
        </el-dropdown-item>
        <el-dropdown-item command="class" v-if="!isLearner">{{
          $t('my_class_name')
        }}</el-dropdown-item>
        <el-dropdown-item command="correct" v-if="isAllowMarked">{{
          $t('mark_correct_person')
        }}</el-dropdown-item>
        <el-dropdown-item command="edit-message" v-if="isAdminOrEditor">{{
          $t('edit_message_notifications')
        }}</el-dropdown-item>
        <el-dropdown-item command="credits" v-if="isAdminOrEditor">
          <div class="flex">
            <span>{{ $t('manage') }}</span>
          </div>
        </el-dropdown-item>
        <el-dropdown-item command="logout">{{ $t('logout') }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <span v-else class="clickable no-login" @click="clickLogin">{{ $t('login_signup') }}</span>
    <!-- 语种 -->
    <el-dropdown
      class="language boderLeft"
      trigger="click"
      :disabled="inGradingPage"
      @command="handleCommandLanguage"
    >
      <div class="title_box">
        <span class="language-name"
          >{{ currentLanguageTitle }} <span class="content-beta" v-if="isShowBeta">Beta</span></span
        >
        <span class="triangle"></span>
      </div>

      <el-dropdown-menu class="language-dropdown" slot="dropdown">
        <el-dropdown-item
          v-for="item in languageList"
          :key="item.value"
          :command="item.value"
          :disabled="item.value === currentLanguage"
        >
          {{ item.title }}<span class="content" v-if="item.isBeta">Beta</span></el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <!-- 货币 -->
    <el-dropdown
      v-if="isLogin"
      class="language"
      trigger="click"
      :disabled="inGradingPage"
      @command="setPersonalInfo"
    >
      <div class="title_box Left20">
        <span class="language-name">{{ currentCurrencyShorthand || $t('currency_type') }} </span>
        <div class="triangle"></div>
      </div>
      <el-dropdown-menu class="language-dropdown" slot="dropdown">
        <el-dropdown-item
          v-for="item in currencyList"
          :key="item.code"
          :command="item.description"
          :disabled="item.description === currentCurrency"
        >
          {{ item.description }}</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { LanguageList } from '@/model/globalData'
import { loadLocale } from '@/locales'
import { setLanguage } from '@/utils/cache'
import { mapState, mapGetters } from 'vuex'
import analytics from '@/utils/AnalyticsCenter'
import { apiRequest } from '@/serves/http'
import { mixinMixpanel } from '@/mixins'
import mixinCurrency from '../mixins/currencyList'
export default {
  name: 'UserOption',
  components: {},
  mixins: [mixinMixpanel, mixinCurrency],
  data() {
    return {
      // 多语言
      currentLanguage: loadLocale(),
      languageList: Object.freeze(LanguageList),
      isUnRead: false,
    }
  },
  computed: {
    ...mapState({
      role: (state) => state.user.role,
      inGradingPage: (state) => state.grade.inGradingPage,
    }),
    ...mapGetters('user', {
      displayName: 'displayName',
    }),
    // 是否登录
    isLogin() {
      console.log('.login', this.$store.state.user.login)
      return this.$store.state.user.login
    },
    // 用户名
    userName() {
      return (
        `${this.$store.state.user.given_name} ${this.$store.state.user.family_name}` ||
        this.$store.state.user.nickname ||
        ''
      )
    },
    // 头像
    userAvatar() {
      return this.$store.state.user.picture || ''
    },
    givenName() {
      return this.$store.state.user.given_name
    },
    isAdminOrEditor() {
      if (this.$store.state.user.role === 'editor' || this.$store.state.user.role === 'admin') {
        return true
      } else {
        return false
      }
    },
    isLearner() {
      return this.$store.state.user.role === 'learner'
    },
    // 多语言
    currentLanguageTitle() {
      const language = this.languageList.find((item) => item.value === this.currentLanguage)
      switch (language?.value) {
        case 'vi':
          return 'VN'
        case 'en':
          return 'EN'
        case 'zh':
          return '中文'
        case 'mn':
          return 'MN'
        case 'fr':
          return 'FR'
        case 'th':
          return 'TH'
        case 'ko':
          return 'KO'
        case 'ja':
          return '日本語'
        default:
          return ''
      }
    },
    isShowBeta() {
      return this.languageList.find((item) => item.value === this.currentLanguage).isBeta
    },
    // 是否允许批改
    isAllowMarked() {
      return ['admin', 'writer'].includes(this.role)
    },
    isFree() {
      return this.$store.state.user.isFree
    },
  },
  mounted() {
    console.log('inGradingPage', this.inGradingPage)
    if (this.isLogin) {
      this.checkUnReadAssignment()
    }
  },
  methods: {
    handleCommandUser(command) {
      let mixpanelParams
      let params
      switch (command) {
        case 'info':
          params = { type: 'My account' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/index/personal-info')
          break
        case 'wallet':
          params = { type: 'My purchases' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/index/mywallet/recharge')
          break
        case 'history':
          params = { type: 'My history' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/index/learn-history')
          break
        case 'class':
          //hskweb_myclass_click埋点
          mixpanelParams = { people_id: this.peopleId, unlimited: this.unlimited }
          analytics.logEvent('hskweb_myclass_click', mixpanelParams)
          params = { type: 'My classes' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/my-class')
          break
        case 'assignment':
          params = { type: 'My assignments' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/my-assignment')
          break
        case 'studentAssignment':
          params = { type: 'Student Assignment' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/stu-assignment')
          break
        case 'correct':
          params = { type: 'Manual assessment' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/manual-correction')
          break
        case 'credits':
          params = { type: 'Lookup users' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/index/management')
          break
        case 'edit-message':
          params = { type: 'Manage notifications' }
          analytics.logEvent('hskweb_avatar_click', params)
          this.$router.push('/personal-center/index/edit-message')
          break
        case 'logout': {
          params = { type: 'Log out' }
          analytics.logEvent('hskweb_avatar_click', params)
          // 点击退出登录 需要判断是否在考试中
          console.log('需要判断是否在考试中,', this.inGradingPage)
          if (this.inGradingPage) {
            console.log('在考试中, 提示保存考试内容')
            this.$store.dispatch('notifLogout', true)
            return
          }
          this.$store.dispatch('user/handleLogout', { reLogin: false })
          break
        }
        default:
          break
      }
    },
    handleCommandLanguage(command) {
      console.log(command)
      let params = {
        type: null,
        before_language: this.currentLanguage,
        after_language: command,
      }
      window.layer.open({
        title: '',
        closeBtn: false,
        content: this.$i18n.messages[command].sure_change_lang,
        btn: [
          this.$i18n.messages[command].change_lang_ok,
          this.$i18n.messages[command].change_lang_cancel,
        ],
        yes: (index) => {
          params.type = 'confirm'
          analytics.logEvent('hskweb_languageswitch_click', params)
          window.layer.close(index)
          setLanguage(command)
          window.location.reload()
        },
        btn2: (index) => {
          params.type = 'cancel'
          analytics.logEvent('hskweb_languageswitch_click', params)
          window.layer.close(index)
        },
      })
    },
    clickLogin() {
      //hskweb_sign_click埋点
      analytics.logEvent('hskweb_sign_click')
      this.$store.dispatch('user/handleLogout', { reLogin: true })
    },
    // 我的作业是否有未读消息
    checkUnReadAssignment() {
      apiRequest.get(ApiPath.search_un_read_assignment).then((res) => {
        this.isUnRead = res?.data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.user-option {
  display: flex;
  align-items: center;

  .user {
    .user-avatar {
      width: 24px;
      height: 24px;
      margin-right: 8px;
      border-radius: 50%;
    }

    .user-name {
      line-height: 24px;
      color: #ffffff;
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .no-login {
    // width: 108px;
    height: 36px;
    border-radius: 18px;
    text-align: center;
    line-height: 36px;
    color: #ffffff;
    background: $yellow;
    font-size: 12px;
    padding: 0px 16px;
  }
  .boderLeft {
    border-left: 1px solid #515571;
    margin-left: 16px;
  }
  .language {
    .language-name {
      display: inline-block;
      position: relative;
      // margin-left: 16px;
      padding-left: 16px;
      font-size: 12px;
      line-height: 24px;
      color: #ffffff;
      white-space: nowrap;
      .content-beta {
        display: inline-block;
        position: absolute;
        font-size: 10px;
        color: #faae56;
        top: -7px;
      }
    }
  }
}
::v-deep.language-dropdown {
  .content {
    display: inline-block;
    font-size: 10px;
    color: #faae56;
    margin-left: 1px;
    vertical-align: 9px;
  }
}
::v-deep .el-badge__content.is-fixed.is-dot {
  top: 6px;
}
.title_box {
  display: flex;
  align-items: center;
}
.triangle {
  // position: relative;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid white;
  margin-left: 6px;
}
.Left20 {
  margin-left: 20px;
}
</style>
